'use client'

import { memo } from 'react'

import { CheckCircle, Circle } from 'lucide-react'

/**
 * Props do componente Words
 */
interface WordsProps {
  words: string[]
  foundWords: string[]
  showWords: boolean
}

/**
 * Componente Words simplificado e bem tipado
 * Segue princípios de Clean Code: componente focado, memoizado
 */
export const Words = memo<WordsProps>(({ words, foundWords, showWords }) => {
  return (
    <div className="bg-purple-50 w-full rounded-lg p-4 mt-4">
      <div className="text-gray-800 font-bold text-start flex justify-between items-center mb-4">
        <span>Palavras encontradas</span>
        <span className="bg-white rounded-full px-3 py-1 text-sm font-medium">
          {foundWords.length}/{words.length}
        </span>
      </div>

      <div className="flex flex-col gap-2">
        {words.map(word => {
          const isFound = foundWords.includes(word)
          const displayWord =
            showWords || isFound ? word : '#'.repeat(word.length)

          return (
            <div key={word} className="flex items-center gap-3">
              {isFound ? (
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
              ) : (
                <Circle className="w-5 h-5 text-purple-300 flex-shrink-0" />
              )}
              <span
                className={`
                  font-medium select-none
                  ${isFound ? 'text-green-700' : 'text-gray-600'}
                `}
              >
                {displayWord}
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
})

Words.displayName = 'Words'
